<template>
  <v-container grid-list-md>
    <pi-progress v-if="progress" main></pi-progress>
    <pi-navigation :navigation="navigation"></pi-navigation>

    <v-card>
      <v-subheader>{{ startDate }}</v-subheader>
      <v-card-text>
        <v-sheet height="500">
          <v-calendar
            ref="calendar"
            color="primary"
            locale="pl-pl"
            :weekdays="[1, 2, 3, 4, 5, 6, 0]"
            v-model="start"
          >
            <template v-slot:day="{ date }">
              <template v-for="event in eventsMap[date]">
                <pi-event
                  :key="event.id"
                  :event="event"
                  @edit="showCreateEditDialog($event)"
                  @delete="showDeleteDialog($event)"
                ></pi-event>
              </template>
            </template>
          </v-calendar>
        </v-sheet>
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" flat @click="prev()" :disabled="progress">
          <v-icon dark left>keyboard_arrow_left</v-icon>Poprzedni
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" flat @click="next()" :disabled="progress">
          Następny
          <v-icon dark right>keyboard_arrow_right</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>

    <pi-dialog
      :dialog="createDialog.on"
      :progress="createDialog.progress"
      :headline="createDialog.isEdit ? 'Edycja wydarzenia' : 'Dodawanie wydarzenia'"
      :operation="createDialog.isEdit ? 'Edytuj' : 'Dodaj'"
      @closed="showCreateEditDialog(false)"
      @action="createEditDate()"
    >
      <v-form ref="dateForm" @submit.prevent lazy-validation>
        <v-text-field
          v-model="createDialog.obj.name"
          :rules="Rules.date.name"
          required
          prepend-icon="person"
          name="name"
          label="Nazwa"
          :disabled="createDialog.progress"
        ></v-text-field>
        <v-text-field
          v-model="createDialog.obj.description"
          :rules="Rules.date.description"
          required
          prepend-icon="person"
          name="description"
          label="Opis"
          :disabled="createDialog.progress"
        ></v-text-field>
        <v-menu v-model="createDialog.menu" lazy>
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="createDialog.obj.date"
              :rules="Rules.date.date"
              required
              prepend-icon="event"
              name="date"
              label="Data"
              v-on="on"
              :disabled="createDialog.progress"
            ></v-text-field>
          </template>
          <v-date-picker
            locale="pl-pl"
            first-day-of-week="1"
            v-model="createDialog.obj.date"
            no-title
            scrollable
            @input="createDialog.menu = false"
          ></v-date-picker>
        </v-menu>
      </v-form>
    </pi-dialog>

    <pi-dialog
      :dialog="deleteDialog.on"
      :progress="deleteDialog.progress"
      headline="Usuwanie wydarzenia"
      operation="Usuń"
      @closed="showDeleteDialog(null)"
      @action="deleteData()"
    >Czy chcesz usunąć grupę {{ deleteDialog.obj.name }}?</pi-dialog>

    <v-btn
      color="accent"
      dark
      bottom
      right
      fab
      fixed
      @click="showCreateEditDialog()"
      v-if="Auth.check(Permissions['DATES_ADDEDIT'])"
    >
      <v-icon>add</v-icon>
    </v-btn>

    <pi-snackbar :color="snackbar.color" :snackbar.sync="snackbar.on" :message="snackbar.message"></pi-snackbar>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    progress: false,
    snackbar: { on: false, color: "error", message: "" },
    navigation: [],
    dates: [],
    createDialog: { on: false, obj: {}, menu: false, progress: false },
    deleteDialog: { on: false, obj: {}, menu: false, progress: false },
    start: new Date()
      .toLocaleDateString("en-GB")
      .split("/")
      .reverse()
      .join("-")
  }),
  props: { isAll: Boolean },
  methods: {
    async getData() {
      this.progress = true;
      const response = await this.Api.send(
        "get",
        `/dates?from=${this.from}&to=${this.to}`
      );
      this.progress = false;
      if (response.status) {
        this.dates = response.dates.map(v => {
          return {
            id: v.id,
            name: v.name,
            description: v.description,
            date: new Date(v.date)
              .toLocaleDateString("en-GB")
              .split("/")
              .reverse()
              .join("-")
          };
        });
        return;
      }
      this.showError(response.message);
    },
    async createNavigation() {
      this.navigation = [{ id: 0, text: "Harmonogram", href: "/schedule" }];
    },
    async showCreateEditDialog(show = true) {
      if (!show) {
        return (this.createDialog.on = false);
      }
      this.createDialog.isEdit = typeof show === "object";
      this.createDialog.obj = this.createDialog.isEdit ? { ...show } : {};
      this.createDialog.on = true;
    },
    async createEditDate() {
      if (!this.$refs.dateForm.validate()) {
        return this.showError("Uzupełnij wymagane pola");
      }
      this.createDialog.progress = true;
      const url = this.createDialog.isEdit
        ? `/dates/${this.createDialog.obj.id}`
        : "/dates";
      const method = this.createDialog.isEdit ? "put" : "post";
      const response = await this.Api.send(method, url, {
        dateData: this.createDialog.obj
      });
      this.createDialog.progress = false;
      if (response.status) {
        this.showSuccess(
          this.createDialog.isEdit
            ? "Wydarzenie zmienione"
            : "Wydarzenie dodane"
        );
        this.showCreateEditDialog(false);
        return this.getData();
      }
      this.showCreateEditDialog(false);
      this.showError(response.message);
    },
    async showDeleteDialog(show = true) {
      if (!show) {
        return (this.deleteDialog.on = false);
      }
      this.deleteDialog.obj = show;
      this.deleteDialog.on = true;
    },
    async deleteData() {
      this.deleteDialog.progress = true;
      const response = await this.Api.send(
        "delete",
        `/dates/${this.deleteDialog.obj.id}`
      );
      this.deleteDialog.progress = false;
      if (response.status) {
        this.showSuccess("Wydarzenie usunięte");
        this.showDeleteDialog(false);
        return this.getData();
      }
      this.showDeleteDialog(false);
      this.showError(response.message);
    },
    async next() {
      this.$refs.calendar.next();
      await this.getData();
    },
    async prev() {
      this.$refs.calendar.prev();
      await this.getData();
    },
    async showError(message) {
      this.snackbar.color = "error";
      this.showMessage(message);
    },
    async showSuccess(message) {
      this.snackbar.color = "success";
      this.showMessage(message);
    },
    async showMessage(message) {
      this.snackbar.message = message;
      this.snackbar.on = true;
    }
  },
  computed: {
    eventsMap() {
      const map = {};
      this.dates.forEach(e => (map[e.date] = map[e.date] || []).push(e));
      return map;
    },
    startDate() {
      return new Date(this.start).toLocaleDateString("pl-PL", {
        month: "long",
        year: "numeric"
      });
    },
    from() {
      const d = new Date(this.start);
      d.setDate(1);
      return d
        .toLocaleDateString("en-GB")
        .split("/")
        .reverse()
        .join("-");
    },
    to() {
      const d = new Date(this.start);
      d.setMonth(d.getMonth() + 1);
      d.setDate(1);
      return d
        .toLocaleDateString("en-GB")
        .split("/")
        .reverse()
        .join("-");
    }
  },
  async mounted() {
    this.createNavigation();
    await this.getData();
  }
};
</script>